import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import UserInfo from "../components/UserInfo";
import {i18nizeDate} from "../helpers/Utils";
import Rbac from "../components/Rbac";

class IdBaseDepositsDetails extends Component {
  render() {
    const {t, itemIndex, transaction, showIdBaseDepositDescriptionForm} = this.props;
    const {id, createdAt, updatedAt, verifier, description} = transaction;
    return (
      <div className="py-2 kyc-details-table">
        <Table bordered responsive>
          <tbody>
            <tr>
              <td style={{width: 200}} className='text-info text-center'>{t('Description')}</td>
              <td className='d-flex flex-row align-items-center border-bottom-0 border-right-0'>
                <span>{description}</span>
                <Rbac permission="update_user-kyc">
                  <i className='icon-Pencil cursor-pointer text-large text-primary mx-1'
                     onClick={() => {showIdBaseDepositDescriptionForm({id}, description, itemIndex);}}/>
                </Rbac>
              </td>
            </tr>
            <tr>
              <td style={{width: 200}} className='text-info text-center'>{t('Request submission date')}</td>
              <td>{i18nizeDate(createdAt)}</td>
            </tr>
            <tr>
              <td style={{width: 200}} className='text-info text-center'>{t('Request update date')}</td>
              <td>{i18nizeDate(updatedAt)}</td>
            </tr>
            <tr>
              <td style={{width: 200}} className='text-info text-center'>{t('Evaluated By')}</td>
              <td>
                <UserInfo
                  textColor="text-dark"
                  label={t('Admin')}
                  id={verifier.id}
                  type="ADMIN"
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(IdBaseDepositsDetails);